import uuid from "../../App/validation/uuid";
import calculate_length from "@turf/length";
import calculate_area from "@turf/area";
import centroid from "@turf/centroid";
import along from "@turf/along";
import st_colors from "../../Data/twenty_colors.json";

const on_draw_toolbox = async ({
  event,
  toolbox = {},
  set_value_toolbox,
  toolbox_handle_routing_mapbox,
  status_toolbox,
  map_object,
  draw_object,
}) => {
  const { mode_toolbox, mode_draw = "simple_select" } = toolbox || {};
  const geojson = event;
  let feature = geojson?.features?.[0];
  let new_uuid = uuid();
  feature.properties.uuid = new_uuid;
  feature.id = new_uuid;
  let uuid_name;

  if (mode_toolbox === "features_distance") {

    let {
      features_distance,
      features_distance_label,
      features_distance_center,
      visible_distance,
    } = toolbox;
    uuid_name = "uuid_distance";
    const selected_row_toolbox_ids = toolbox?.[uuid_name];

    const length_km = calculate_length(feature, {
      units: "kilometers",
    }).toFixed(4);
    const length_m = Number(Number(length_km) * 1000).toFixed(1);

    const last_number = features_distance.length === 0 ? 0 : +(features_distance.at(-1)?.properties?.id_tool?.split("-")?.[1]);
    const id_tool = `D-${last_number + 1}`;
    feature.properties.id_tool = id_tool;
    feature.properties.length_km = length_km;
    feature.properties.length_m = length_m;
    features_distance.push(feature);
    const center_length = length_km / 2;

    let point = along(feature, center_length, { units: "kilometers" });
    point.properties.uuid = feature.properties.uuid;
    point.properties.id_tool = id_tool;
    const coordinates_a = feature.geometry.coordinates[0];
    const coordinates_b =
      feature.geometry.coordinates[feature.geometry.coordinates.length - 1];
    const features_label = [
      {
        type: "Feature",
        properties: { name: "A", parent_uuid: feature.properties.uuid },
        geometry: { type: "Point", coordinates: coordinates_a },
      },
      {
        type: "Feature",
        properties: { name: "B", parent_uuid: feature.properties.uuid },
        geometry: { type: "Point", coordinates: coordinates_b },
      },
    ];
    features_distance_label = [...features_distance_label, ...features_label];
    features_distance_center.push(point);
    set_value_toolbox({ key: "features_distance", value: features_distance });
    set_value_toolbox({
      key: "features_distance_label",
      value: features_distance_label,
    });
    set_value_toolbox({
      key: "features_distance_center",
      value: features_distance_center,
    });

    set_value_toolbox({
      key: uuid_name,
      value: [...selected_row_toolbox_ids, feature.properties.uuid]
    });

    set_value_toolbox({
      key: "visible_distance",
      value: [...visible_distance, feature.properties.uuid]
    });

    setTimeout(() => {
      map_object.setFeatureState(
        { source: "geojson_distance", id: new_uuid },
        { selected: true }
      );
    }, 100);

  } else if (mode_toolbox === "features_area") {
    let { features_area, features_area_center, visible_area } = toolbox;
    uuid_name = "uuid_area";
    const selected_row_toolbox_ids = toolbox?.[uuid_name];
    const area_meter_square = calculate_area(feature).toFixed(1);
    const area_hectare = parseFloat((area_meter_square / 10_000).toFixed(2));
    const last_number = features_area.length === 0 ? 0 : +(features_area.at(-1)?.properties?.id_tool?.split("-")?.[1]);
    const id_tool = `A-${last_number + 1}`;
    feature.properties.area_meter_square = area_meter_square;
    feature.properties.area_hectare = area_hectare;
    feature.properties.id_tool = id_tool;
    features_area.push(feature);
    const geojson = { type: "FeatureCollection", features: [feature] };
    let point = centroid(geojson);
    point.properties.uuid = feature.properties.uuid;
    point.properties.id_tool = id_tool;
    features_area_center.push(point);
    set_value_toolbox({ key: "features_area", value: features_area });
    set_value_toolbox({
      key: uuid_name,
      value: [...selected_row_toolbox_ids, feature.properties.uuid]
    });
    set_value_toolbox({
      key: "features_area_center",
      value: features_area_center,
    });

    set_value_toolbox({
      key: "visible_area",
      value: [...visible_area, feature.properties.uuid]
    });
    setTimeout(() => {
      map_object.setFeatureState(
        { source: "geojson_area", id: new_uuid },
        { selected: true }
      );
    }, 100);
  } else if (mode_toolbox === "features_elevation") {
    let { features_elevation, features_elevation_center, visible_elevation } = toolbox;
    uuid_name = "uuid_elevation";
    const selected_row_toolbox_ids = toolbox?.[uuid_name] || [];
    const length_km = calculate_length(feature, {
      units: "kilometers",
    }).toFixed(2);
    const length_m = length_km * 1000;
    const last_number = features_elevation.length === 0 ? 0 : +(features_elevation.at(-1)?.properties?.id_tool?.split("-")?.[1]);
    const id_tool = `E-${last_number + 1}`;
    feature.properties.id_tool = id_tool;
    feature.properties.length_km = length_km;
    feature.properties.length_m = length_m;
    const center_length = length_km / 2;
    let point = along(feature, center_length, { units: "kilometers" });
    point.properties.uuid = feature.properties.uuid;
    point.properties.id_tool = id_tool;

    features_elevation.push(feature);
    features_elevation_center.push(point);

    set_value_toolbox({ key: "features_elevation", value: features_elevation });
    const new_selected_row_toolbox_ids = [...selected_row_toolbox_ids, feature.properties.uuid];
    set_value_toolbox({
      key: uuid_name,
      value: new_selected_row_toolbox_ids
    });

    setTimeout(() => {
      map_object.setFeatureState(
        { source: "geojson_elevation", id: feature.properties.uuid },
        { selected: true }
      );
    }, 100);

    set_value_toolbox({
      key: "features_elevation_center",
      value: features_elevation_center,
    });
    set_value_toolbox({
      key: "visible_elevation",
      value: [...visible_elevation, feature.properties.uuid]
    });
    // generate_elevation(feature);
  } else if (mode_toolbox === "features_radius") {
    let { default_radius_km, default_radius_m, features_radius, visible_radius } = toolbox;
    uuid_name = "uuid_radius";
    const selected_row_toolbox_ids = toolbox?.[uuid_name];
    const last_number = features_radius.length === 0 ? 0 : +(features_radius.at(-1)?.properties?.id_tool?.split("-")?.[1]);
    const id_tool = `R-${last_number + 1}`;
    feature.properties.id_tool = id_tool;
    feature.properties.radius_km = default_radius_km;
    feature.properties.radius_m = default_radius_m;
    features_radius.push(feature);
    set_value_toolbox({ key: "features_radius", value: features_radius });
    set_value_toolbox({
      key: uuid_name,
      value: [...selected_row_toolbox_ids, feature.properties.uuid]
    });
    set_value_toolbox({
      key: "visible_radius",
      value: [...visible_radius, feature.properties.uuid]
    });
    setTimeout(() => {
      map_object.setFeatureState(
        { source: "geojson_radius", id: new_uuid },
        { selected: true }
      );
    }, 100);
  } else if (mode_toolbox === "features_isochrone") {
    const {
      // isochrone_profile,
      // contour_type,
      // contours_minutes,
      // contours_meters,
      features_isochrone, // point
      visible_isochrone,
    } = toolbox;
    const isochrone_index = features_isochrone.length;
    uuid_name = "uuid_isochrone";
    const isochrone_polygon_id = "geojson_isochrone_polygon";
    const selected_row_toolbox_ids = toolbox[uuid_name];
    const last_number = features_isochrone.length === 0 ? 0 : +(features_isochrone.at(-1)?.properties?.id_tool?.split("-")?.[1]);
    const id_tool = `I-${last_number + 1}`;
    feature.properties.id_tool = id_tool;
    feature.properties.color = st_colors[isochrone_index % st_colors.length];
    // feature.properties.isochrone_profile = isochrone_profile;
    // feature.properties.contour_type = contour_type;
    // feature.properties.contours_minutes = contours_minutes;
    // feature.properties.contours_meters = contours_meters;
    // feature.properties.center = feature.geometry.coordinates;

    set_value_toolbox({ key: "features_isochrone", value: [...features_isochrone, feature] });
    set_value_toolbox({
      key: "visible_isochrone",
      value: [...visible_isochrone, feature.properties.uuid]
    });
    set_value_toolbox({
      key: uuid_name,
      value: [...selected_row_toolbox_ids, feature.properties.uuid]
    });
    setTimeout(() => {
      map_object.setFeatureState(
        { source: isochrone_polygon_id, id: new_uuid },
        { selected: true }
      );
    }, 100);
    // generate_isokron(feature);
  } else if (mode_toolbox === "features_routing") {
    let { features_routing_obj, visible_routing, routing_active_uuid } = toolbox;
    const feature_routing_active = features_routing_obj?.data?.[routing_active_uuid];

    if (feature_routing_active?.point?.length < 10 || !feature_routing_active?.point) {
      set_value_toolbox({
        key: "last_saved_feature_uuid",
        value: "",
      })

      let order = features_routing_obj?.order || [];
      uuid_name = "uuid_routing";
      const selected_row_toolbox_ids = toolbox?.[uuid_name];

      if (!routing_active_uuid || !order?.includes(routing_active_uuid)) {
        const new_uuid = uuid();
        set_value_toolbox({
          key: "routing_active_uuid",
          value: new_uuid,
        });
        routing_active_uuid = new_uuid;
        order = [...order, new_uuid];

        set_value_toolbox({
          key: uuid_name,
          value: [...selected_row_toolbox_ids, new_uuid]
        });
        set_value_toolbox({
          key: "visible_routing",
          value: [...visible_routing, new_uuid]
        });
      };


      //tambahkan titik baru di feature_routing yang sudah ada
      const is_any_feature_obj = !!feature_routing_active;
      let feature_obj = {};

      const last_feature_uuid = features_routing_obj?.order?.at(-1);
      const last_id_tool = features_routing_obj?.data?.[last_feature_uuid]?.lineString?.properties?.id_tool?.split("-")?.at(-1)
      const id_tool = `Ro-${!isNaN(last_id_tool) ? Number(last_id_tool) + 1 : 1}`;

      if (!is_any_feature_obj) {
        let feature_obj_point = [...(feature_obj?.point || []), feature];
        feature_obj.point = feature_obj_point;
        feature_obj.lineString = { properties: { id_tool, uuid: routing_active_uuid } };
      } else {
        feature_obj = { ...feature_routing_active };
        let feature_obj_point = [...(feature_obj?.point || []), feature];
        feature_obj.point = feature_obj_point;
      }

      set_value_toolbox({
        key: "features_routing_obj",
        value: {
          ...features_routing_obj,
          order: order,
          data: {
            ...features_routing_obj?.data,
            [routing_active_uuid]: feature_obj
          }
        }
      });

      await toolbox_handle_routing_mapbox();
    };
  }

  if (draw_object) {
    set_value_toolbox({ key: "mode_draw", value: mode_draw });
    draw_object?.deleteAll();
    requestAnimationFrame(() => {
      map_object.getCanvas().style.cursor = "crosshair";
      draw_object?.changeMode(mode_draw);
    });
  }

  status_toolbox();
};

export default on_draw_toolbox;
